module.exports = __webpack_public_path__ + "img/deviceOffline.4cd757dd.svg";